import done from '../../../../../assets/done.svg';
import donepending from '../../../../../assets/donepending.svg';
import donegray from '../../../../../assets/donegray.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Grid } from '@mui/material';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;

  @media (max-width: 899px) {
    padding: 1rem 0;
  }
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  justify-content: center;
  max-width: 1457px;
  margin: 0 auto;
  padding-top: 2rem;

  @media (max-width: 1200px) {
    padding-top: 1.5rem;
  }

  @media (max-width: 899px) {
    padding-top: 2rem;
    padding: 20px;
    margin: 0;
    width: 100%;
  }
`;

const HeaderContainer = styled(Container)`
  position: relative;
  z-index: 2;
`;

const TimelineDivider = styled.div`
  position: absolute;
  height: 50px;
  transform: rotate(-3deg);
  transform-origin: ${props => props.transformOrigin || 'left'};
  z-index: 1;
  overflow: hidden;
  background: transparent;
  left: 0;
  width: 103%;
  top: 320px;
  margin-bottom: 25px;
  position: relative;

  &::before{
    content:'';
    display:block;
    background-color: #E3E6EA;
    width: 50%;
    height: 3px;
    position: absolute;
    right: 0;
    top: 24px;
  }
  &::after{
    content:'';
    display:block;
    background-color: #7DAAF3;
    width: 50%;
    height: 3px;
    position: absolute;
    left:0;
    top: 24px;
  }
  @media (max-width: 1440px) {
    top: 320px;
  }
  @media (max-width: 1200px) {
    top: 260px;
  }
`;

const BlueLine = styled(Grid)`
  position: relative;
  &::after {
    content: '';
    background-color: #7DAAF3;
    display: block;
    height: 3px;
    width: 100%;
    position: absolute;
    left: 0px;
    top: 24px;
  }
  &.lightBlue{
    &::after {
      background-color: #E3E6EA;
      @media (max-width:1350px) {
        left: 30px;
      }
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 0px;
    width: 3px;
    height: 100px;
    background-color: #7DAAF3;
    z-index: 1;
    transform: rotate(3deg);
  }
  &.lightBlue{
    &::before {
      background-color: #E3E6EA;
    }
  }
  
  @media (max-width:1440px){
    
  }
`;

const QuarterCard = styled.div`
  flex: 0 0 100%;
  padding: 0 2rem;
  position: relative;
  padding-top: 3.3rem;
  margin-bottom: 2rem;
  
  ${props => {
    const transformValues = [
      'translateY(2rem)',
      'translateY(0)',
      'translateY(-2rem)',
      'translateY(2rem)',
      'translateY(-0.5rem)',
      'translateY(-2rem)'
    ];
    return `transform: ${transformValues[props.index % 6]};`;
  }}
  
  @media (min-width: 900px) {
    flex: 0 0 50%;
  }
  
  @media (min-width: 1024px) {
    flex: 0 0 33.333%;
  }

  @media (min-width: 900px) and (max-width: 1200px) {
    flex: 0 0 33.333%;
    padding: 0 1rem;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 899px) {
    flex: 0 0 100%;
    transform: none;
    padding: 1rem;
    margin: 0 0.5rem;
    border: 1px solid rgba(125, 170, 243, 0.2);
    border-radius: 12px;
    background-color: rgba(240, 248, 255, 0.5);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
`;

const HeaderCard = styled(QuarterCard)`
  height: 170px;
  padding-bottom: 0;
  margin-bottom: 0;

  @media (min-width: 900px) and (max-width: 1200px) {
    height: 180px;
    padding-bottom: 0;
  }
  
  @media (min-width: 1600px) {
    height: 200px;
  }
  
  @media (min-width: 2000px) {
    height: 220px;
  }

  @media (max-width: 899px) {
    height: auto;
    border: none;
    box-shadow: none;
    background-color: transparent;
    padding-bottom: 0;
  }
`;

const TaskCard = styled(QuarterCard)`
  padding-top: 0;
  margin-top: 0;
  
  @media (max-width: 899px) {
    padding-top: 1rem;
    border: 1px solid rgba(125, 170, 243, 0.2);
    border-radius: 12px;
    background-color: rgba(240, 248, 255, 0.5);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
`;

const QuarterTitle = styled.h2`
  font-size: 2.5rem;
  color: #000;
  font-weight: 500;
  margin-bottom: 0.20rem;
  margin-top: ${props => props.index % 3 === 0 ? '0' : '0.25rem'};
  opacity: ${props => props.index % 3 === 2 ? '0.5' : '1'};
  ${props => {
    const transformValues = [
      'translateY(0.50rem)',
      'translateY(0)',
      'translateY(-0.65rem)',
      'translateY(0.75rem)',
      'translateY(0.45rem)',
      'translateY(-0.45rem)'
    ];
    return `transform: ${transformValues[props.index % 6]};`;
  }}

  @media (min-width: 900px) and (max-width: 1200px) {
    font-size: 2.5rem;
    margin-bottom: 0.1rem;
  }

  @media (max-width: 899px) {
    font-size: 1.8rem;
    margin-top: 0;
    transform: none;
    opacity: 1;
  }
`;

const QuarterSubtitle = styled.p`
  font-size: 1.125rem;
  opacity: 0.5;
  margin-bottom: 1rem;
  color: #000;
  transform: ${props => {
    if (props.index % 3 === 0) return 'translateY(-0.5rem)';
    if (props.index % 3 === 1) return 'translateY(-0.75rem)';
    if (props.index % 3 === 2) return 'translateY(-1.6rem)';
    return 'translateY(0)';
  }};

  @media (min-width: 900px) and (max-width: 1200px) {
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    overflow: visible;
    text-overflow: clip;
  }

  @media (max-width: 899px) {
    font-size: 1rem;
    transform: none;
    margin-bottom: 0.5rem;
  }
`;

const TaskList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 4rem;
  display: flex;  
  flex-direction: column;
  gap: 0.75rem;
  animation: ${slideInRight} 0.4s ease forwards;
  opacity: 0;

  @media (min-width: 900px) and (max-width: 1200px) {
    margin-top: 2.5rem;
    gap: 0.6rem;
  }

  @media (max-width: 899px) {
    margin-top: 0;
    width: 100%;
    animation: ${slideInRight} 0.3s ease forwards;
  }
`;

const TaskItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border: 3px solid #CFE5FF;
  border-radius: 15px;
  color: #030930;
  user-select: none;
  white-space: pre-line;
  padding: 0.75rem 1.25rem;
  background-color: ${props => (props.textLength > 100 ? '#F0F8FF' : '#F0F8FF')};
  font-size: 15px;
  width: fit-content;
  min-width: 280px;
  max-width: ${props => props.textLength > 0 ? '430px' : '340px'};
  
  opacity: 0;
  animation: ${fadeInUp} 0.5s ease forwards;
  animation-delay: ${props => props.animationDelay}s;

  @media (min-width: 900px) and (max-width: 1200px) {
    min-width: 220px;
    max-width: 290px;
    padding: 0.6rem 0.8rem;
    font-size: 13px;
    border-width: 2px;
  }

  @media (max-width: 899px) {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    animation: ${fadeInUp} 0.3s ease forwards;
    animation-delay: ${props => Math.min(props.animationDelay * 0.7, 0.2)}s;
  }
`;

const StatusIcon = styled.img`
  width: 30px;
  height: 30px;
  flex-shrink: 0;

  @media (min-width: 900px) and (max-width: 1200px) {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 899px) {
    width: 24px;
    height: 24px;
  }
`;

const SliderWrapper = styled.div`
  position: relative;
  
  .slick-track {
    display: flex;
  }
  .slick-slide {
    height: inherit;
    > div {
      height: 100%;
    }
  }
  .slick-dots {
    bottom: -40px;
  }
  .slick-arrow {
    z-index: 10;
    &:before {
      font-size: 24px;
    }
  }
  .slick-prev {
    left: -15px;
    @media (max-width: 899px) {
      left: 5px;
    }
  }
  .slick-next {
    right: -15px;
    @media (max-width: 899px) {
      right: 5px;
    }
  }

  @media (max-width: 899px) {
    width: 100%;
    margin: 0 auto;
    .slick-list {
      padding: 0 !important;
    }
  }
`;

const MobileNavButton = styled.button`
  display: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.8);
  border: 2px solid rgba(125, 170, 243, 0.6);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #030930 !important;
  outline: none;
  
  @media (max-width: 899px) {
    display: flex;
  }
  
  &:active {
    transform: translateY(-50%) scale(0.97);
  }
  
  &.prev {
    left: 5px;
  }
  
  &.next {
    right: 5px;
  }
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 1rem;
`;

const TabButton = styled.button`
  padding: 0.75rem 1.5rem;
  margin: 0 0.5rem;
  border: none;
  border-radius: 8px;
  background-color: ${props => props.active ? '#0A1038' : '#E3E6EA'};
  color: ${props => props.active ? '#fff' : '#666'};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.active ? '#0A1038' : '#D0D5DD'};
  }
  
  @media (max-width: 899px) {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    margin: 0 0.25rem;
  }
`;

const RoadmapCarousel = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [animationKey, setAnimationKey] = useState(0);
  const [taskListKey, setTaskListKey] = useState(0);
  const [activeTab, setActiveTab] = useState('developers');
  const containerRef = useRef(null);
  const sliderRef = useRef(null);
  const taskSliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [isExtraLargeScreen, setIsExtraLargeScreen] = useState(false);
  const [isExtraExtraLargeScreen, setIsExtraExtraLargeScreen] = useState(false);

  // Roadmap data for different user groups
  const roadmapDataByGroup = {
    developers: [
      {
        quarter: 'Q2 2025',
        title: 'Vendor Onboarding and Storefront Development',
        items: [
          { text: 'Vendor Store Release', status: 'not-started' },
          { text: 'Storefront Features', status: 'not-started' },
          { text: 'AI-Powered Product Recommendations', status: 'not-started' },
          { text: 'Product Customization Integration', status: 'not-started' }
        ]
      },
      {
        quarter: 'Q3 2025',
        title: 'Laying the Groundwork for Scale',
        items: [
          { text: 'Integrate USDT Payment Gateway across platform services', status: 'not-started' },
          { text: 'Begin architecture for SIM provisioning services', status: 'not-started' },
          { text: 'Begin UI/UX Design Phase for the AICM mobile application', status: 'not-started' },
          { text: 'Final development of PRISM ', status: 'not-started' },
           { text: 'Upgrade AI Sales Agent with conversational intelligence and analytics', status: 'not-started' },
         {
          text: `Develop and test 4 new bots:\n 1. Market Making (MM) Bot\n 2. Buy Generation Bot for KOLs\n 3. Smart Selling Bot for KOLs\n 4. Affiliate Bot`,
          status: 'not-started'
        },
        ]
      },
      {
        quarter: 'Q4 2025',
        title: 'Expanding the Ecosystem and User Reach',
        items: [
          { text: 'Develop AICM Mobile App  (iOS & Android)', status: 'not-started' },
          { text: 'Launch PRISM Discovery dApp (Mainnet release)', status: 'not-started' },
          { text: 'Develop Freelance Marketplace (Phase 1): KOLs, MODs, Writers, Designers, Developers', status: 'not-started' },
          { text: 'Add support for Card Services Integration', status: 'not-started' },
          { text: 'Extend multi-token support and improve vendor dashboards', status: 'not-started' },
          { text: 'Build backend analytics modules for merchant performance', status: 'not-started' },
          { text: 'Roll out frontend/backend enhancements across the main site', status: 'not-started' },
          { text: 'Implement Search algorithm improvements and enhanced cart performance', status: 'not-started' },
        ]
      }
    ],
    users: [
      {
        quarter: 'Q2 2025',
        title: 'Vendor Onboarding and Storefront Development',
        items: [
          { text: 'Vendor Store Release', status: 'not-started' },
          { text: 'Storefront Features', status: 'not-started' },
          { text: 'AI-Powered Product Recommendations', status: 'not-started' },
          { text: 'Product Customization Integration', status: 'not-started' }
        ]
      },
      {
        quarter: 'Q3 2025',
        title: 'Laying the Groundwork for Scale',
        items: [
         { text: 'Weekly New Listings (Products & Services)\n  o Each with: Listing → Sneak Peek → Live status', status: 'not-started' },
          { text: 'First sneak peeks and demos of PRISM', status: 'not-started' },
          { text: 'Access to gift cards, services', status: 'not-started' },
          { text: 'Product how-to videos and usage guides', status: 'not-started' },
          { text: 'Feedback collection', status: 'not-started' },
          { text: 'Live buybacks during VC sessions using Market Making Bot', status: 'not-started' },
        ]
      },
      {
        quarter: 'Q4 2025',
        title: 'Expanding the Ecosystem and User Reach',
        items: [
          { text: 'PRISM available for all', status: 'not-started' },
          { text: 'Access to Card Services (brands)', status: 'not-started' },
          { text: 'Buy using ETH, USDT, AICM and more', status: 'not-started' },
          { text: 'Incentivized review system on listings', status: 'not-started' },
          { text: 'Gamified engagement: XP, streaks, badges', status: 'not-started' },
        ]
      }
    ],
    community: [
      {
        quarter: 'Q2 2025',
        title: 'Vendor Onboarding and Storefront Development',
        items: [
          { text: 'Vendor Store Release', status: 'not-started' },
          { text: 'Storefront Features', status: 'not-started' },
          { text: 'AI-Powered Product Recommendations', status: 'not-started' },
          { text: 'Product Customization Integration', status: 'not-started' }
        ]
      },
      {
        quarter: 'Q3 2025',
        title: 'Laying the Groundwork for Scale',
        items: [
          { text: 'AMAs and project spotlights', status: 'not-started' },
          { text: 'KOL Campaigns on rotation', status: 'not-started' },
          { text: 'Community updates: Listings, revenue stats, buybacks', status: 'not-started' },
          { text: 'Weekly announcements to maintain visibility', status: 'not-started' },
          { text: 'Feature updates and AI upgrades announced in public', status: 'not-started' },
          { text: 'Reinforcement of resilience message despite KOL sell-offs, focus on consistent delivery and ecosystem expansion', status: 'not-started' }
        ]
      },
      {
        quarter: 'Q4 2025',
        title: 'Expanding the Ecosystem and User Reach',
        items: [
          { text: 'New listings, revenue stats, and visible buybacks', status: 'not-started' },
          { text: 'Testing AICM Mobile App with community', status: 'not-started' },
          { text: 'Community-led feature suggestions in PRISM', status: 'not-started' },
          { text: 'Monthly recap posts with metrics + future goals', status: 'not-started' },
          { text: 'Enhanced partner visibility inside PRISM', status: 'not-started' },
          { text: 'Continued KOL activations + community spotlight program', status: 'not-started' },
        ]
      }
    ]
  };

  const roadmapData = roadmapDataByGroup[activeTab];

  const calculateActiveSegments = () => {
    return roadmapData.map(quarter => {
      return quarter.items.some(item => 
        item.status === 'completed' || item.status === 'pending'
      );
    });
  };
  
  const activeSegments = calculateActiveSegments();

  const isQuarterActive = (quarter) => {
    return quarter.items.some(item => 
      item.status === 'completed' || item.status === 'pending'
    );
  };

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 899);
      setIsTablet(width > 899 && width <= 1200);
      setIsLargeScreen(width > 1200 && width <= 1599);
      setIsExtraLargeScreen(width >= 1600 && width < 2000);
      setIsExtraExtraLargeScreen(width >= 2000);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    // Reset slider when tab changes
    setTaskListKey(prev => prev + 1);
    setActiveSlide(0);
  }, [activeTab]);

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return done;
      case 'pending':
        return donepending;
      case 'not-started':
      default:
        return donegray;
    }
  };

  const goPrev = () => {
    if (taskSliderRef.current) {
      taskSliderRef.current.slickPrev();
    }
  };

  const goNext = () => {
    if (taskSliderRef.current) {
      taskSliderRef.current.slickNext();
    }
  };

  const groupedRoadmapData = isMobile 
    ? roadmapData.map(item => [item])
    : (() => {
        const groups = [];
        for (let i = 0; i < roadmapData.length; i += 3) {
          groups.push(roadmapData.slice(i, i + 3));
        }
        return groups;
      })();

  const taskSettings = {
    dots: isMobile,
    infinite: false,
    speed: isMobile ? 300 : 500, 
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    draggable: true,
    swipe: true,
    fade: true,
    cssEase: 'ease-out',
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          adaptiveHeight: true,
        },
      },
    ],
    beforeChange: (current, next) => {
      setTaskListKey(prevKey => prevKey + 1);
      setActiveSlide(next);
    }
  };

  return (
    <Wrapper>
      <TabContainer>
        <TabButton 
          active={activeTab === 'developers'} 
          onClick={() => setActiveTab('developers')}
        >
          Developers
        </TabButton>
        <TabButton 
          active={activeTab === 'users'} 
          onClick={() => setActiveTab('users')}
        >
          Users
        </TabButton>
        <TabButton 
          active={activeTab === 'community'} 
          onClick={() => setActiveTab('community')}
        >
          Community
        </TabButton>
      </TabContainer>

      {/* Timeline divider with separate configuration */}
      {!isMobile && (
        <TimelineDivider>
          <Container style={{padding:0}}>
            <Grid container>
              <BlueLine md={4}></BlueLine>
              <BlueLine md={4}></BlueLine>
              <BlueLine md={4} className='lightBlue'></BlueLine>
            </Grid>
          </Container>
        </TimelineDivider>
      )}

      <SliderWrapper>
        <Slider {...taskSettings} ref={taskSliderRef}>
          {groupedRoadmapData.map((group, groupIndex) => (
            <div key={`group-${groupIndex}-${taskListKey}`}>
              <HeaderContainer>
                {group.map((quarterData, index) => {
                  const absoluteIndex = isMobile 
                    ? groupIndex 
                    : groupIndex * 3 + index;
                  const styleIndex = absoluteIndex % 6;
                  const isQuarterActiveStatus = isQuarterActive(quarterData);
                  
                  return (
                    <HeaderCard key={`header-${absoluteIndex}`} index={styleIndex}>
                      <QuarterTitle index={styleIndex}>{quarterData.quarter}</QuarterTitle>
                      <QuarterSubtitle index={styleIndex}>{quarterData.title}</QuarterSubtitle>
                    </HeaderCard>
                  );
                })}
              </HeaderContainer>
              
              <Container style={{ paddingTop: isTablet ? '0.5rem' : '1rem' }}>
                {group.map((quarterData, index) => {
                  const absoluteIndex = isMobile 
                    ? groupIndex 
                    : groupIndex * 3 + index;
                  const styleIndex = absoluteIndex % 6;
                  const baseDelay = isMobile ? 0 : index * 0.25;
                  
                  return (
                    <TaskCard key={`tasks-${absoluteIndex}`} index={styleIndex}>
                      <TaskList key={`tasklist-${absoluteIndex}-${taskListKey}`}>
                        {quarterData.items.map((item, idx) => {
                          const taskDelay = isMobile 
                            ? Math.min(idx * 0.08, 0.2)
                            : baseDelay + (idx * 0.15);
                          
                          return (
                            <TaskItem 
                              key={idx} 
                              textLength={item.text.length}
                              animationDelay={taskDelay}
                            >
                              <StatusIcon src={getStatusIcon(item.status)} alt={item.status}/>
                              {item.text}
                            </TaskItem>
                          );
                        })}
                      </TaskList>
                    </TaskCard>
                  );
                })}
              </Container>
            </div>
          ))}
        </Slider>
      </SliderWrapper>
    </Wrapper>
  );
};

export default RoadmapCarousel;